import { render, staticRenderFns } from "./PlanOrder.vue?vue&type=template&id=5a463b3c"
import script from "./PlanOrder.vue?vue&type=script&lang=js"
export * from "./PlanOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports